<div class="modal-container">
  <div class="header">
    <img src="assets/icons/admin-company-picker/mechanic.svg" alt="mechanic_icon" class="modal-image" />
    <div class="title">{{ 'AppCompanyPicker.YouAreAdmin' | translate }}</div>
    <div class="subtitle">{{ 'AppCompanyPicker.SelectCompanySubtitle' | translate }}</div>
  </div>

  <div class="form">
    <div class="filter-container">
      <div class="company-options-container">
        <div
          class="company-options"
          [style.height]="expanded ? 'auto' : '35px'"
          [style.max-height]="expanded ? '300px' : '35px'"
        >
          <div class="company-options-expander">
            <div class="company-options-expander-text">{{ 'AppCompanyPicker.SelectCompany' | translate }}</div>
            <div>
              <mat-icon class="expanded-icon" (click)="toggleOptions()"
                >{{ expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon
              >
            </div>
          </div>

          <mat-icon *ngIf="loading"><mat-spinner color="primary" diameter="30"> </mat-spinner></mat-icon>

          <div *ngIf="expanded">
            <mat-form-field class="custom-mat-form-field filter-field">
              <input
                matInput
                (keyup)="applyFilter($event.target.value)"
                [(ngModel)]="filterValue"
                (ngModelChange)="applyFilter($event)"
                autocomplete="off"
                (focus)="true"
                placeholder="{{ 'AppComponent.Search' | translate }}"
              />
            </mat-form-field>

            <div class="scrollbar overflow">
              <div class="company-option" (click)="onCompanySelect(c)" *ngFor="let c of filteredCompanies">
                <div>{{ c.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="buttons-container">
        <button class="logout-btn" (click)="logout()">{{ 'AppComponent.Logout' | translate }}</button>

        <button
          mat-raised-button
          class="confirm-btn"
          color="#243757"
          [disabled]="isSelected()"
          matRipple
          (click)="onConfirm()"
        >
          {{ 'AppCompanyPicker.Confirm' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
